var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-pictures flex flex-align-center flex-just-center",on:{"click":function($event){return _vm.$emit('close')}}},[_c('img',{attrs:{"src":_vm.src,"alt":""},on:{"click":function($event){$event.stopPropagation();_vm.isShow = false}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }